// Module
var code = `<div>
  <div class="btn-group">
      <label
        ng-repeat="item in \$ctrl.options"
        ng-class="{active : \$ctrl.selectedId === item.id}"
        class="btn btn-primary"
      >
        <input class="ng-hide" type="radio" ng-value="item.id" ng-model="\$ctrl.selectedId" ng-change="\$ctrl.updateModel()">{{item.label}}
      </label>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/toggle-buttons/toggle-buttons.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;